// Pushes video engagement events to the GTM dataLayer.
// Usage: <video v-track-video="'lipton-case-study'" ...>
//
// Events (all carry video_id, video_index, video_title, video_url, page_path):
//   video_start     - first play of a viewing (again after it completes)
//   video_progress  - at 25 / 50 / 75 percent, with video_percent
//   video_complete  - reached the end (also detected when a looping video wraps)

export const VIDEO_REGISTRY = {
  'homepage-showreel': { index: 1, title: 'Homepage showreel' },
  'delonghi-case-study': { index: 2, title: "De'Longhi case study" },
  'britvic-true-brit-case-study': { index: 3, title: 'Britvic True Brit case study' },
  'lipton-case-study': { index: 4, title: 'Lipton case study' },
  'human-rights-case-study': { index: 5, title: 'Human Rights case study' },
  'pepsi-max-case-study': { index: 6, title: 'Pepsi Max case study' },
  'campari-case-study': { index: 7, title: 'Campari case study' },
  'marriott-case-study': { index: 8, title: 'Marriott case study' },
  'asahi-case-study': { index: 9, title: 'Asahi case study' },
};

const MILESTONES = [25, 50, 75];

const push = (event, el, extra = {}) => {
  const info = VIDEO_REGISTRY[el._videoId] || { index: 0, title: el._videoId };
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event,
    video_id: el._videoId,
    video_index: info.index,
    video_title: info.title,
    video_url: el.currentSrc || el.src,
    page_path: window.location.pathname,
    ...extra,
  });
};

export default {
  mounted(el, binding) {
    el._videoId = binding.value;
    const state = { started: false, sent: new Set(), lastTime: 0 };

    const complete = () => {
      push('video_complete', el, { video_percent: 100 });
      state.started = false;
      state.sent.clear();
      state.lastTime = 0;
    };

    const onPlay = () => {
      if (state.started) return;
      state.started = true;
      push('video_start', el);
    };

    const onTimeUpdate = () => {
      const { currentTime, duration } = el;
      if (!state.started || !duration || !isFinite(duration)) return;

      // Looping videos never fire "ended"; treat a jump from the end back to the start as completion.
      if (currentTime < state.lastTime - 1 && state.lastTime >= duration * 0.9) {
        complete();
        return;
      }
      state.lastTime = currentTime;

      const percent = (currentTime / duration) * 100;
      MILESTONES.forEach((m) => {
        if (percent >= m && !state.sent.has(m)) {
          state.sent.add(m);
          push('video_progress', el, { video_percent: m });
        }
      });
    };

    el.addEventListener('play', onPlay);
    el.addEventListener('timeupdate', onTimeUpdate);
    el.addEventListener('ended', complete);
    el._videoTrackingCleanup = () => {
      el.removeEventListener('play', onPlay);
      el.removeEventListener('timeupdate', onTimeUpdate);
      el.removeEventListener('ended', complete);
    };
  },
  unmounted(el) {
    if (el._videoTrackingCleanup) el._videoTrackingCleanup();
  },
};
